import { BaseApplicationService } from "../../domain/base/base-application-service";
import { BannerNoticeType } from "../../domain/notifi-from-graffer/banner-notice";
import { CloudGovApiError } from "../../domain/api-error";
import { toast } from "react-toastify";
import apiClient from "../../apis/tenant-management/tenant-management-client";
import { reportUnexpectedError } from "../../../error-reporter";
import { GrafferNotifService } from "../../domain/notifi-from-graffer/notif-from-graffer-service";

export type BannerNoticeServiceProps = {
  isLoading: boolean;
  currentSetting: BannerNoticeType | undefined;
  onMount: typeof BannerNoticeService.prototype.onMount;
  onSave: typeof BannerNoticeService.prototype.onSave;
  onDelete: typeof BannerNoticeService.prototype.onDelete;
};

export class BannerNoticeService extends BaseApplicationService<BannerNoticeServiceProps> {
  state = {
    isLoading: false,
    currentSetting: undefined,
    onMount: this.onMount.bind(this),
    onSave: this.onSave.bind(this),
    onDelete: this.onDelete.bind(this),
  };

  async onMount() {
    this.fetchCurrentBannerSetting();
  }

  async onSave(setting: BannerNoticeType) {
    try {
      if (!(await this.checkSlugExists(setting.cosmicJSSlug))) {
        return;
      }
      await apiClient.saveNotice(setting);
      toast.success("設定を更新しました");
      await this.fetchCurrentBannerSetting();
    } catch (e) {
      if (!this.handleRetryableError(e)) {
        reportUnexpectedError(e);
        toast.error("更新に失敗しました。");
      }
    }
  }

  async onDelete() {
    try {
      await apiClient.deleteNotice();
      toast.success("設定を削除しました");
      await this.fetchCurrentBannerSetting();
    } catch (e) {
      if (!this.handleRetryableError(e)) {
        reportUnexpectedError(e);
        toast.error("削除に失敗しました。");
      }
    }
  }

  private async checkSlugExists(slug: string) {
    try {
      await GrafferNotifService.fetchBySlug(slug);
      return true;
    } catch (e) {
      toast.error(
        `「${slug}」の記事確認に失敗しました. CosmicJSのslugが正しいか、公開しているかを確認してください。` +
          e.message,
      );
      return false;
    }
  }

  private async fetchCurrentBannerSetting() {
    try {
      this.setState({ isLoading: true });
      const { data } = await apiClient.fetchBannerNotice();
      this.setState({
        currentSetting: data,
      });
    } catch (e) {
      if (!CloudGovApiError.is404(e)) {
        reportUnexpectedError(e);
        toast.error(e.message);
      }
      this.setState({
        currentSetting: undefined,
      });
      return;
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }
}
